<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="modal-header flex flex-row justify-between items-center">
    <h1>Create Support Ticket</h1>

    <mat-dialog-actions>
      <button class="material-icons" mat-dialog-close
              particleAnalytics
              analyticsCategory="ed-cell-editor-container"
              analyticsAction="close-btn"><i class="fa-regular fa-xmark"></i>
      </button>
    </mat-dialog-actions>

  </div>

  <mat-dialog-content class="full-grow-no-shrink-no-basis">
    <form class="flex flex-col full-grow-no-shrink-no-basis" [formGroup]="supportTicketForm"
          (keydown.enter)="$event.preventDefault()">
      <div class="flex flex-col flex-1-0-auto ">

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Title</mat-label>
            <input matInput required formControlName="title"
                   particleAnalytics
                   analyticsCategory="account-settings"
                   analyticsAction="password-input" autofocus>
            <mat-error *ngIf="supportTicketFormErrors.title.hasOwnProperty('required')">
              Title is required.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-row justify-start items-start auto-flex">
          <mat-form-field appearance="outline" class="flex-1-1-100">
            <mat-label>Description</mat-label>
            <textarea matInput rows="6" required formControlName="description"
                      particleAnalytics
                      analyticsCategory="account-settings" analyticsAction="password-input"></textarea>
            <mat-error *ngIf="supportTicketFormErrors.description.hasOwnProperty('required')">
              Description is required.
            </mat-error>
          </mat-form-field>
        </div>

      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
    <button mat-button class="orbitax-footer-button" [mat-dialog-close]="result">Cancel</button>
    <button mat-button (click)="onSave()" [mat-dialog-close]="result" mat-flat-button
            class="orbitax-footer-action-button mat-button mat-flat-button mat-accent" type="button" color="accent"
            [disabled]="!supportTicketForm.valid" cdkFocusInitial>Save
    </button>
  </mat-dialog-actions>
</div>
